<ids-shimmer class="ids-d-flex ids-flex-column ids-justify-content-between" [show]="showConditionalShimmer">
  <section>
    <ids-mobile-header [scrollElement]="bgBaseScroll">
      <button
        id="minor"
        idsMobileHeaderControls
        idsIconButton
        title="{{ labelBtnBack }}"
        aria-label="{{ labelBtnBack }}"
        (click)="backPage()"
        (focus)="ariaLabelPage = false"
        class="ids-pb-5"
      >
        fechar
      </button>
    </ids-mobile-header>
  </section>
  <section style="overflow: scroll;" #bgBaseScroll [attr.aria-hidden]="ariaLabelPage">
    <div class="ids-container ids-py-5">
      <div class="ids-row">
        <div class="ids-col-12">
          <ids-icon size="L" variant="alert" aria-hidden="true">aviso_outline</ids-icon>
          <h1 class="ids-title -small -bold ids-py-2">
            No momento, não é possível criar seu cadastro na corretora
          </h1>
          <p class="ids-body-text -variant ids-py-2">
            Identificamos que você tem menos de 18 anos e não podemos seguir com
            esta solicitação.
          </p>
          <p class="ids-body-text -variant ids-py-2 ids-mb-3">
            Contate a Itaú Corretora para saber mais, em dias úteis, das 9h às
            18h.
          </p>
          <div class="ids-mb-3">
            <a class="ids-link ids-py-1 custom-link" href="tel:40044828" aria-label="Capitais e regiões metropolitanas, 4004 4828" role="link" (click)="clickTelCap()">
              <span aria-hidden="true"><span class="ids-body-text -small -bold ids-py-1">Capitais e regiões metropolitanas<br></span>4004 4828</span>
            </a>          
          </div>
          <div class="ids-mb-3">
            <a class="ids-link ids-py-1 custom-link" href="tel:08009704828" aria-label="Demais localidades, 0800 970 4828" role="link" (click)="clickTelLoc()">
              <span aria-hidden="true"><span class="ids-body-text -small -bold ids-py-1">Demais localidades<br></span>0800 970 4828</span>
            </a> 
          </div>
          <div class="ids-mb-3">
            <p class="ids-body-text -small -bold ids-py-1">
              Para clientes com deficiência auditiva e de fala. Todos os dias, 24h
              por dia.
            </p>
            <a class="ids-link ids-py-1 custom-link" href="tel:40041999" aria-label="Capitais e regiões metropolitanas, 4004 1999" role="link" (click)="clickDefTelCap()">
              <span aria-hidden="true"><span class="ids-body-text -small -bold ids-py-1">Capitais e regiões metropolitanas<br></span>4004 1999</span>
            </a>
          </div>
          <div class="ids-mb-3">
            <a class="ids-link ids-py-1 custom-link" href="tel:08007211999" aria-label="Demais localidades, 0800 721 1999" role="link" (click)="clickDefTelLoc()">
              <span aria-hidden="true"><span class="ids-body-text -small -bold ids-py-1">Demais localidades<br></span>0800 721 1999</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div
    class="ids-container ids-py-6 ids-color-bg-base"
    style="position: sticky; bottom: 0"
    [attr.aria-hidden]="ariaLabelPage"
  >
    <div class="ids-row-fixed-12">
      <div class="ids-col-12">
        <button idsMainButton full (click)="handleClick($event)" aria-label="Entendi" id="minor-next">
          Entendi
        </button>
      </div>
    </div>
  </div>
</ids-shimmer>
